const shipmentSettingsStored = JSON.parse(
  localStorage.getItem("shipmentSettingsStored") as string
);
const initialState = shipmentSettingsStored
  ? { shipmentSettings: shipmentSettingsStored }
  : { shipmentSettings: {} };

export const shipmentSettings = {
  namespaced: true,
  state: initialState,
  actions: {
    setShipmentSettings(
      { commit }: any,
      current: { settings: any; index: any }
    ) {
      commit("setShipmentSettings", current);
      localStorage.setItem(
        "shipmentSettingsStored",
        JSON.stringify(this.state.shipmentSettings.shipmentSettings)
      );
    },
  },
  mutations: {
    setShipmentSettings(state: any, current: any) {
      state.shipmentSettings[current.index] = current.settings;
    },
  },
};
